import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface PricingSectionProps {
    primaryColor: string;
    isEditing: boolean;
    sizeClasses: { heading: string; subheading: string; body: string; small: string };
}

export function PricingSection({ primaryColor, isEditing, sizeClasses }: PricingSectionProps) {
    const editClass = isEditing ? 'outline-dashed outline-2 outline-blue-400 outline-offset-2' : '';

    return (
        <section className="py-20 px-6 bg-gray-50 @container">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">Simple Pricing</h2>
                <div className="grid @md:grid-cols-3 gap-8">
                    {[
                        { name: 'Starter', price: '$29', features: ['Feature 1', 'Feature 2', 'Feature 3'] },
                        { name: 'Pro', price: '$79', features: ['Everything in Starter', 'Feature 4', 'Feature 5'] },
                        { name: 'Enterprise', price: '$199', features: ['Everything in Pro', 'Feature 6', 'Priority Support'] }
                    ].map((plan, idx) => (
                        <div key={idx} className="p-8 bg-white rounded-2xl border-2 border-gray-200 hover:border-blue-500 transition-colors">
                            <h3
                                className={`${sizeClasses.subheading} font-bold text-gray-900 mb-2 ${editClass}`}
                                contentEditable={isEditing}
                                suppressContentEditableWarning
                            >
                                {plan.name}
                            </h3>
                            <p
                                className={`text-4xl font-bold mb-6 ${editClass}`}
                                style={{ color: primaryColor }}
                                contentEditable={isEditing}
                                suppressContentEditableWarning
                            >
                                {plan.price}<span className="text-lg text-gray-600">/mo</span>
                            </p>
                            <ul className="space-y-3 mb-8">
                                {plan.features.map((feature, fIdx) => (
                                    <li key={fIdx} className="flex items-center gap-2">
                                        <Icon name="CheckIcon" className="w-5 h-5 text-green-600" />
                                        <span
                                            className={`${sizeClasses.body} text-gray-600 ${editClass}`}
                                            contentEditable={isEditing}
                                            suppressContentEditableWarning
                                        >
                                            {feature}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                            <button
                                className="w-full py-3 rounded-lg font-semibold transition-colors"
                                style={{ backgroundColor: primaryColor, color: 'white' }}
                            >
                                Get Started
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
